import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Provider } from 'react-redux';
import store from './store/store';
import ErrorBoundary from './app/ErrorBoundary';
import { themeV2 } from './components/theme/themeV2';
import PrivateRouteV2 from './components/auth/PrivateRoute';
import AuthBootstrap from './app/AuthBootstrap';

import HomePageV2 from './pages/Home/HomePageV2';
import PackagesPageV2 from './pages/Packages/PackagesPageV2';
import PackageDetailsPageV2 from './pages/PackageDetailsV2/PackageDetailsPageV2';
import BookingPageV2 from './pages/BookingV2/BookingPageV2';
import CustomizedBookingPageV2 from './pages/BookingV2/CustomizedBookingPageV2';
import BookingConfirmationPageV2 from './pages/BookingV2/BookingConfirmationPageV2';
import LoginPageV2 from './pages/AuthV2/LoginPageV2';
import RegisterPageV2 from './pages/AuthV2/RegisterPageV2';
import DashboardPageV2 from './pages/DashboardV2/DashboardPageV2';
import ProfilePageV2 from './pages/ProfileV2/ProfilePageV2';
import FlightsPageV2 from './pages/FlightsV2/FlightsPageV2';
import FlightQuoteTrackPage from './pages/FlightsV2/FlightQuoteTrackPage';
import FlightQuoteReceiptPage from './pages/FlightsV2/FlightQuoteReceiptPage';
import ContactPageV2 from './pages/ContactV2/ContactPageV2';
import HelpCenterPageV2 from './pages/HelpCenterV2/HelpCenterPageV2';

const LegacyRedirect = ({ template }) => {
  const params = useParams();
  const path = Object.entries(params).reduce(
    (acc, [key, value]) => acc.replace(`:${key}`, value),
    template
  );
  return <Navigate to={path} replace />;
};

function App() {
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AuthBootstrap />
        <ThemeProvider theme={themeV2}>
          <CssBaseline />
          <Router
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <div className="App">
              <Routes>
                <Route path="/" element={<Navigate to="/v2" replace />} />

                <Route path="/v2" element={<HomePageV2 />} />
                <Route path="/v2/packages" element={<PackagesPageV2 />} />
                <Route path="/v2/packages/:id" element={<PackageDetailsPageV2 />} />
                <Route path="/v2/flights" element={<FlightsPageV2 />} />
                <Route path="/v2/flights/track" element={<FlightQuoteTrackPage />} />
                <Route path="/v2/flights/receipt" element={<FlightQuoteReceiptPage />} />
                <Route path="/v2/booking/:packageId" element={<BookingPageV2 />} />
                <Route path="/v2/customized-booking" element={<CustomizedBookingPageV2 />} />
                <Route path="/v2/customize" element={<CustomizedBookingPageV2 />} />
                <Route path="/v2/booking-confirmation/:id" element={<BookingConfirmationPageV2 />} />
                <Route path="/v2/login" element={<LoginPageV2 />} />
                <Route path="/v2/register" element={<RegisterPageV2 />} />
                <Route path="/v2/dashboard" element={<PrivateRouteV2><DashboardPageV2 /></PrivateRouteV2>} />
                <Route path="/v2/profile" element={<PrivateRouteV2><ProfilePageV2 /></PrivateRouteV2>} />
                <Route path="/v2/contact" element={<ContactPageV2 />} />
                <Route path="/contact" element={<ContactPageV2 />} />
                <Route path="/v2/help" element={<HelpCenterPageV2 />} />
                <Route path="/help" element={<HelpCenterPageV2 />} />
                <Route path="/v2/services" element={<HelpCenterPageV2 />} />
                <Route path="/services" element={<HelpCenterPageV2 />} />

                {/* Legacy V1 paths → V2 equivalents */}
                <Route path="/packages" element={<Navigate to="/v2/packages" replace />} />
                <Route path="/packages/:id" element={<LegacyRedirect template="/v2/packages/:id" />} />
                <Route path="/flights" element={<Navigate to="/v2/flights" replace />} />
                <Route path="/login" element={<Navigate to="/v2/login" replace />} />
                <Route path="/register" element={<Navigate to="/v2/register" replace />} />
                <Route path="/booking/:packageId" element={<LegacyRedirect template="/v2/booking/:packageId" />} />
                <Route path="/customized-booking" element={<Navigate to="/v2/customized-booking" replace />} />
                <Route path="/customize" element={<Navigate to="/v2/customize" replace />} />
                <Route path="/booking-confirmation/:id" element={<LegacyRedirect template="/v2/booking-confirmation/:id" />} />
                <Route path="/dashboard" element={<Navigate to="/v2/dashboard" replace />} />
                <Route path="/profile" element={<Navigate to="/v2/profile" replace />} />
                <Route path="/bookings/:id" element={<Navigate to="/v2/dashboard" replace />} />

                <Route path="*" element={<Navigate to="/v2" replace />} />
              </Routes>
            </div>
          </Router>
        </ThemeProvider>
      </Provider>
    </ErrorBoundary>
  );
}

export default App;
